import React, { Component, Fragment, pureComponent } from 'react';
import { inject, observer } from 'mobx-react';

@inject('lineStore', 'dictStore')
@observer
export default class Selecter extends Component {

  handleSelect = (type) => {
    this.props.lineStore.basket.setBetType(type);
  }

  render() {
    const { betType } = this.props.lineStore.basket.basketData;
    const { getLang } = this.props.dictStore;

    return (
      <div className="basket-bet-type-cont">
        <ul className="basket-bet-type clearfix">
          <li className={`basket-bet-type-item ${betType == 1 ? "basket-bet-type-item-selected" : ""}`} onClick={() => this.handleSelect(1)} >{getLang('BET_SINGLE')}</li>
          <li className={`basket-bet-type-item basket-bet-type-item-border ${betType == 2 ? "basket-bet-type-item-selected" : ""}`} onClick={() => this.handleSelect(2)} >{getLang('BET_EXPRESS')}</li>
          <li className={`basket-bet-type-item ${betType == 3 ? "basket-bet-type-item-selected" : ""}`} onClick={() => this.handleSelect(3)} >{getLang('BET_SYSTEM')}</li>
        </ul>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/selector.js